import { useCallback, useMemo, useState } from 'react';
import { FormState } from 'final-form';
import { FieldInputValue } from 'components/Forms';
import {
  AppointmentConflict,
  AppointmentConflictsResult
} from 'store/slices/appointments';

export function useAppointmentEngineerConflicts() {
  const [selectedEngineerIds, setSelectedEngineerIds] = useState<string[]>([]);
  const [appointmentConflicts, setAppointmentConflicts] = useState<
    AppointmentConflict[]
  >([]);

  const onFormSpyChange = useCallback(
    (state: FormState<Record<string, any>, Partial<Record<string, any>>>) => {
      const engineerField = state.values.engineer;
      if (!Array.isArray(engineerField)) return;

      const ids = (engineerField as FieldInputValue[]).map(e => e.value);

      if (JSON.stringify(ids) !== JSON.stringify(selectedEngineerIds)) {
        setSelectedEngineerIds(ids);
        setAppointmentConflicts(prev =>
          prev.filter(engineerConflict =>
            ids.includes(engineerConflict.engineerId)
          )
        );
      }

      if (state.submitting && appointmentConflicts.length > 0) {
        setAppointmentConflicts([]);
      }
    },
    [appointmentConflicts, selectedEngineerIds]
  );

  const handleConflictResult = useCallback(
    (conflicts: AppointmentConflictsResult): void => {
      if (!conflicts?.length) return;
      setAppointmentConflicts(conflicts);
    },
    []
  );

  const conflictedEngineerIds = useMemo(
    () => appointmentConflicts.map(c => c.engineerId),
    [appointmentConflicts]
  );

  return {
    appointmentConflicts,
    conflictedEngineerIds,
    selectedEngineerIds,
    onFormSpyChange,
    handleConflictResult
  };
}
